<template>
  <table class="table">
    <thead>
    <slot name="columns">
      <tr>
        <th :key="column" v-for="column in columns">{{column}}</th>

        <th v-if="hasActions()">Actions</th>
      </tr>
    </slot>
    </thead>
    <tbody>
    <tr :key="index" v-for="(item, index) in data">
      <slot :row="item">
        <td :key="column" v-for="column in columns" v-if="hasValue(item, column)"  v-on:click="itemSelected(item)">{{itemValue(item, column)}}
        </td>
        <td v-if="hasActions()">
          <font-awesome-icon style="margin-left: 10px" :icon="`${action.icon}`" v-for="action in actions"
                             v-on:click="handleAction(item, action.handler)"/>
        </td>
      </slot>
    </tr>
    </tbody>
  </table>
</template>
<script>
  function camelize(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
      if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
      return index === 0 ? match.toLowerCase() : match.toUpperCase();
    });
  }

  export default {
    name: 'l-table-actions',
    props: {
      columns: Array,
      data: Array,
      mapValue: Object,
      actions: Array,
      types: Map,
      selectionHandler: Object
    },
    methods: {
      hasValue(item, column) {
        return item[column.toLowerCase()] !== 'undefined'
      },
      itemValue(item, column) {
        let cam = camelize(column);

        if(this.mapValue && cam in this.mapValue && item[cam] in this.mapValue[cam]) {
          return this.mapValue[cam][item[cam]];
        } else {
          return item[cam];
        }
      },
      hasActions() {
        return this.actions != null && this.actions.length > 0;
      },
      handleAction: (item,handler) => {
        handler(item);
      },
      itemSelected(item) {
        console.log(item);
        if(this.selectionHandler !== null) {
          this.selectionHandler(item);
        }
      },
    }
  }
</script>
<style>
</style>
